export const baseURL:
  | "https://erp-voucher.mocion.io"
  | "https://erp.mocion.io"
  | "https://erp-dev.mocion.io"
  | "https://erp-stage.mocion.io" = "https://erp-stage.mocion.io";

export const SOCKET_URL = "wss://erp-voucher.mocion.io/websocket/";
export const LOGIN = "auth/login";
export const REGISTER = "auth/register";
export const VERFIY = "auth/verification";

export const COURT = "club/court";

// club
export const CREATE_CLUB = "club";

// pricing
export const PRICING = "/club/pricelists";
const enviromentLinkType = () => {
  //@ts-ignore
  if (baseURL === "https://erp-stage.mocion.io") {
    return "stage";
    //@ts-ignore
  } else if (baseURL === "https://erp-voucher.mocion.io") {
    return "stage";
  }
  //@ts-ignore
  else if (baseURL === "https://erp-dev.mocion.io") {
    return "dev";
  } else if (baseURL === "https://erp.mocion.io") {
    return "live";
  }
};
const linkType = enviromentLinkType();

// Store original console methods
const originalConsole: any = { ...console };

// Override the global console
window.console = new Proxy(console, {
  get(target, prop: string) {
    const disabledMethods = ["log", "warn", "error", "info", "debug", "trace"];

    // if (disabledMethods.includes(prop)) {
    //   if (linkType === "live") {
    //     return () => {}; // Return empty function in live
    //   }
    // }

    // Return original method for other cases
    return originalConsole[prop];
  },
});
